import _ from "lodash";
import { initialState } from "../redux/reducer/prenotationReducer";
import { isLoggedUser } from "./Auth";

const KEY = "redux";
export function loadState() {
  try {
    const serializedState = localStorage.getItem(KEY);
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.log("Load State error:", e);
    return undefined;
  }
}

export async function saveState(state: any) {
  try {
    if(isLoggedUser(state.login.user)){
      let prenotation = _.cloneDeep(initialState);
      prenotation.order = state.prenotation.order;
      prenotation.orderAs = state.prenotation.orderAs
      let objectState = {
        "login": state.login,
        "prenotation": prenotation
      }
      const serializedState = JSON.stringify(objectState);

      localStorage.setItem(KEY, serializedState);
    }else{
      localStorage.removeItem(KEY);
    }
   
  } catch (e) {
    console.log("Save State error:", e);
  }
}

